// extracted by mini-css-extract-plugin
export default {"container":"DailyReportsCleanUp_container__AkQg-","notesWrapper":"DailyReportsCleanUp_notesWrapper__k-xqJ"};